import React, { useEffect, useState } from 'react';
import CloseImage from '../../assets/ic_close.png';
import { Typography } from "@material-ui/core";
import { TextField } from '@material-ui/core'; 
import api from '../api';
import Autocomplete from '@material-ui/lab/Autocomplete';
import CustomTextField from '../components/customTextField';

export default function DetailRoom(props) { 
    const [listBuilding, setListBuilding] = useState([])
    const [building, setBuilding] = useState(null)
    const [ruangan, setRuangan] = useState("")
    const [floor, setFloor] = useState("")
    const [errorName, setErrorName] = React.useState(false)
    const [errorLantai, setErrorLantai] = React.useState(false)
    const [errorBuilding, setErrorBuilding] = React.useState(false)
    const [texterrorname, setTextErrorName] = React.useState(null)
    const [texterrorLantai, setTextErrorLantai] = React.useState(null)
    const [texterrorBuilding, setTextErrorBuilding] = React.useState(null)

    useEffect(() => {
        getDetailRoom()
    }, [])

    const getDetailRoom = () => {
        api.create().getDetailRoom(props.id).then(response => {
            console.log(response);
            if (response.data) {
                setFloor(response.data.data.floor)
                setRuangan(response.data.data.name)
                getDataBuilding(response.data.data.building_id)
                forceUpdate()
            }
        })
    }

    const getDataBuilding = (value) => {
        api.create().getBuilding().then(response => {
            console.log(response)
            if (response.data) {
                let listBuilding = []
                response.data.data.map((item, index) => {
                    if (item.deleted_at === null) {
                        listBuilding.push({
                            id: item.id,
                            name: String(item.name).trim()
                        })
                    }
                })

                let indexID = listBuilding.findIndex((val) => val.id === value)
                if (indexID > -1) {
                    setBuilding(listBuilding[indexID])
                }
                setListBuilding(listBuilding)
            }
        })
    }


    const handleEdit = () => {
        let regNumber = /^[0-9]+$/
        if (!ruangan) {
            setErrorName(true)
            setTextErrorName("Nama ruangan wajib diisi")
        } else if (!floor) {
            setErrorLantai(true)
            setTextErrorLantai("Lantai wajib diisi")
        } else if (building === null) {
            setErrorBuilding(true)
            setTextErrorBuilding("Gedung wajib diisi")
        } else if (!regNumber.test(floor)) {
            setErrorLantai(true)
            setTextErrorLantai("inputan harus berisi angka")
        } else {
            let payload = {
                "id": props.id,
                "name": ruangan,
                "floor": floor,
                "building_id": building.id
            }
            api.create().updateRoom(payload).then(response => {
                console.log(response);
                if (response.data) {
                    if (response.data.status === true) {
                        props.onClose()
                        props.getData()
                    } else {
                        alert(response.data.message)
                    }
                }
            })
        }

    }

    const forceUpdate = React.useReducer(bool => !bool)[1];

    return (
        <div className="App app-popup-show">
            <div className="popup-content background-white" style={{ borderRadius: 8 }}>
                <div className="popup-panel grid grid-2x main-color" style={{ height: 64, borderTopRightRadius: 8, borderTopLeftRadius: 8 }}>
                    <div className="col-1" style={{ maxWidth: "inherit", display: 'flex', alignItems: 'center' }}>
                        <div className="popup-title">
                            <span style={{ color: 'black', fontSize: 18, }}>Edit Ruangan</span>
                        </div>
                    </div>
                    <div className="col-2 content-right" style={{ maxWidth: "inherit", alignSelf: 'center' }}>
                        <button
                            type="button"
                            className="btn btn-circle btn-white"
                            onClick={() => props.onClose()}
                        >
                            <img src={CloseImage} style={{ width: 20, height: 20 }} />
                        </button>
                    </div>
                </div>

                <div className="grid grid-2x grid-mobile-none gap-15px" style={{ padding: 20, paddingRight: 50, paddingLeft: 50 }}>
                    <div className="column-1">
                        <CustomTextField
                            required={true}
                            label={"Nama Ruangan"}
                            value={ruangan}
                            error={errorName}
                            helperText={texterrorname}
                            onChange={(val) => {
                                setRuangan(val)
                                setErrorName(false)
                                setTextErrorName(null)
                            }}
                        />

                        <div style={{ marginTop: 15 }}>
                            <CustomTextField
                                required={true}
                                label={"Lantai"}
                                type="number"
                                value={floor}
                                error={errorLantai}
                                helperText={texterrorLantai}
                                onChange={(val) => {
                                    setFloor(val)
                                    setErrorLantai(false)
                                    setTextErrorLantai(null)
                                }}
                            />
                        </div>
                    </div>
                    <div className="column-2">
                        <Autocomplete
                            // multiple
                            style={{ marginTop: 1 }}
                            options={listBuilding}
                            getOptionLabel={(option) => option.name}
                            debug
                            name='building_name'
                            id="building_name"
                            onChange={(event, newInputValue) => {
                                setBuilding(newInputValue)
                                setErrorBuilding(false)
                                setTextErrorBuilding("")
                                forceUpdate()
                            }}
                            renderInput={(params) =>
                                <TextField
                                    {...params}
                                    InputProps={{ ...params.InputProps, style: { fontSize: 13 } }}
                                    InputLabelProps={{ style: { color: '#7e8085' } }}
                                    label="Gedung"
                                    required={true}
                                    error={errorBuilding}
                                    helperText={texterrorBuilding}
                                />
                            }
                            value={building}
                        />
                    </div>
                </div>
                <div className="border-top grid grid-2x" style={{ height: 56, backgroundColor: '#f5f5f5', paddingLeft: 20, paddingRight: 20, borderBottomLeftRadius: 20, borderBottomRightRadius: 20 }}>
                    <div className="column-1" style={{ alignSelf: 'center' }}>
                    </div>
                    <div className="column-2" style={{ display: 'flex', justifyContent: 'flex-end', alignItems: 'center' }}>
                        <div onClick={() => props.onClose()} style={{ height: 32, width: 50, backgroundColor: "transparent", borderRadius: 20, marginRight: 10, cursor: 'pointer' }} >
                            <Typography style={{ color: '#706d6d', fontSize: 15, marginTop: 5 }}>Batal</Typography>
                        </div>
                        <div onClick={(e) => handleEdit()} style={{ height: 32, width: 150, backgroundColor: '#2a9c6c', borderRadius: 20, boxShadow: '5px 2px 10px 0 #999999', cursor: 'pointer' }} >
                            <Typography style={{ color: 'white', fontSize: 15, marginTop: 5 }}>Simpan</Typography>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}